import {Component, OnInit, inject} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import localeEn from '@angular/common/locales/en-CA';
import localeFr from '@angular/common/locales/fr-CA';
import {NavigationCancel, Router, RouterOutlet} from '@angular/router';
import {filter} from 'rxjs/operators';
import {LoadingBarModule} from '@ngx-loading-bar/core';
import {HeaderComponent} from './header/header.component';
import {TabBarComponent} from './common/tab-bar/tab-bar.component';
import {FooterComponent} from './footer/footer.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [LoadingBarModule, HeaderComponent, TabBarComponent, RouterOutlet, FooterComponent, TranslateModule]
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);


  // Keep track of the input method that last triggered our listener logic.  Avoid calling the selector and add/remove methods when we don't need to
  // private keyboardLastUsedInput = false;

  constructor() {
    const router = this.router;

    // Log any redirections
    router.events.pipe(
      filter((e): e is NavigationCancel => e instanceof NavigationCancel)
    ).subscribe(e => {
      console.info('Redirecting', e.reason);
    });
  }

  ngOnInit() {
    registerLocaleData(localeEn, 'en-CA');
    registerLocaleData(localeFr, 'fr-CA');
  }

}
